<template>
	<base-card :title="title" class="mt-28 ">
		<template #action>
			<span class="header_time">{{$moment(date||'').format('YYYY-MM-DD')}}</span>
		</template>
		<div class="doctor_card">
			<img :src="doctor.avatar" fit="cover" />
			<div class="content">
				<div
					><span>{{doctor.name}}</span> {{doctor.title}}</div
				>
				<div class="mt-24">{{doctor.hospitalName}}</div>
			</div>
		</div>
		<div v-for="(item,index) in list" :key="index">
			<div class="doctor_msg_title" v-if="item.label">{{ item.label }}</div>
			<div class="doctor_msg_content" v-if="item.value">{{item.value}}</div>
		</div>
	</base-card>
</template>
<script>
export default {
    name: 'reportDoctorCard',
    props: {
        title: {
            type: String,
            default: ''
        },
        date: {
            type: String,
            default: ''
        },
        doctor: {
            type: Object,
            default: () => { }
        },
        list: {
            type: Array,
            default: () => []
        }
    }
}
</script>
<style lang="less" scoped>
.header_time {
	font-size: 28px;
	color: @gray-9;
	text-align: right;
	float: right;
}
.doctor_card {
	display: flex;
	align-items: center;
	margin-bottom: 10px;
	img {
		width: 88px;
		height: 88px;
		border-radius: 12px;
		margin-right: 24px;
	}
	.content {
		font-size: 28px;
		color: #000000;
		vertical-align: bottom;
		span {
			font-size: 34px;
			font-weight: bold;
		}
	}
	.mt-24 {
		margin-top: 16px;
	}
}
.doctor_msg_title {
	font-size: 28px;
	margin: 28px 0;
	color: @primary;
	font-weight: bold;
}
.doctor_msg_content {
	border-radius: 18px;
	background-color: #f5f6f7;
	padding: 26px;
	font-size: 24px;
	color: #3d3d3d;
}
</style>